export default "__VITE_ASSET__1f8a0c4e__"